(function() {

  'use strict';

  function EncomendaEditarCtrl($scope, $rootScope, $stateParams, Pedido, Encomenda) {

    function carregarDados() {
      var idEncomenda = Number($stateParams.idEncomenda);
      var listaEncomendas = Pedido.getPedido().remessas;
      var encomenda = _.find(listaEncomendas, {id: idEncomenda});

      encomenda.servicoEnvio = encomenda.codigoServicoEnvio;

      Encomenda.setEncomenda(angular.copy(encomenda));

      $scope.$parent.vm.isCepPreenchido = true;

      $rootScope.$broadcast('etiqueta:destinatario:alterado', Encomenda.getEncomenda().destinatario);
      $rootScope.$broadcast('etiqueta:formaEnvio:alterada', Encomenda.getEncomenda().servicoEnvio);

      // Se está usando algum serviço adicional, mostra a seção e carrega valores
      // de AR e MP.
      if (Encomenda.getEncomenda().referencia || Encomenda.getEncomenda().qrCodes.length) {
        $scope.$parent.vm.utilizarServicoOpcional = true;
      }

      // Trata array de qrcodes.
      Encomenda.getEncomenda().qrCodes = Encomenda.getEncomenda().qrCodes.join();

      // trata o campo cpf na edicao.
      Encomenda.getEncomenda().destinatario.cpf = encomenda.destinatario.cpf ? encomenda.destinatario.cpf : encomenda.destinatario.cnpj;

      $scope.$parent.vm.buscaTipoEntregaPorCep(true);

      return encomenda;
    }

    function carregarCheckbox(encomenda) {
      $scope.$parent.vm.checkTenhoNF.value = (encomenda.tipoDocumentoOrigem === 'NFe');
    }

    function carregarVD() {
      var valor = $scope.$parent.vm.getEncomenda().valorDeclarado;
      var servico = $scope.$parent.vm.getEncomenda().servicoEnvio;

      // quando Carta e VD zero, manda null para diferenciar o nulo do
      // outros valores.
      if (servico === 'CartaRegistrada') {
        valor = 0;
      }
    }

    function carregarEncomenda() {
      Pedido.getPedidoAsync()
        .then(carregarDados)
        .then(carregarCheckbox)
        .then($scope.$parent.vm.podeAdicionarRemessa = true)
        .then($scope.$parent.vm.searchShow = false)
        .then($scope.$parent.vm.podeEscolherFormaEnvio = false)
        .then(carregarVD)
        .catch(function(err) {
          $scope.tratarErrosBackEnd(err);
        });
    }

    carregarEncomenda();
  }

  angular
    .module('mandaeApp')
    .controller('EncomendaEditarCtrl', EncomendaEditarCtrl);

})();
